import { Symbology } from '@scandit/web-datacapture-barcode'
import { range } from '../utils/range'

// will be dynamically filled with the default active symbols count inside the SettingsStore.ts#init
export const defaultRangeBySymbology: { [key in Symbology]?: number[] } = {
  [Symbology.Code11]: [],
  [Symbology.Code25]: [],
  [Symbology.Code39]: [],
  [Symbology.Code93]: [],
  [Symbology.Codabar]: [],
  [Symbology.InterleavedTwoOfFive]: [],
  [Symbology.MSIPlessey]: [],
  [Symbology.Code128]: [],
}

const forFifty = Array.from(range(4, 50))
const threeThirtyTwo = Array.from(range(3, 32))

export const extendedRangeBySymbology: { [key in Symbology]?: number[] } = {
  [Symbology.MSIPlessey]: threeThirtyTwo,
  [Symbology.Code128]: forFifty,
  [Symbology.Code11]: threeThirtyTwo,
  [Symbology.Code25]: threeThirtyTwo,
  [Symbology.Code39]: Array.from(range(3, 40)),
  [Symbology.Code93]: Array.from(range(5, 60)),
  [Symbology.Codabar]: Array.from(range(3, 34)),
  [Symbology.GS1DatabarExpanded]: Array.from(range(1, 11)),
  [Symbology.InterleavedTwoOfFive]: forFifty,
  [Symbology.RoyalMail4state]: forFifty,
  [Symbology.KIX]: forFifty,
}
